export default __webpack_public_path__ + "static/media/placeholder_store03-jp-web.ef076aef.png";